export const selectFlowHealthLoading = (state) =>
  state?.candidateTouchpointReport?.isLoading;
export const selectFlowHealthChart = (state) =>
  state?.candidateTouchpointReport?.data;

export const selectTableData = (state) =>
  state?.candidateTouchpointReport?.table;
export const selectChartData = (state) =>
  state?.candidateTouchpointReport?.chart;

export const selectDrilldownData = (state) =>
  state?.candidateTouchpointReport?.drilldownData;
export const selectDrilldownDataIsLoading = (state) =>
  state?.candidateTouchpointReport?.drilldownIsLoading;
export const selectTotalCount = (state) =>
  state?.candidateTouchpointReport?.totalCount;
export const selectCurrentDrillPage = (state) =>
  state?.candidateTouchpointReport?.currentDrillPage;
export const selectSearchTerm = (state) =>
  state?.candidateTouchpointReport?.searchTerm;
export const selectInitialLoading = (state) =>
  state?.candidateTouchpointReport?.initialLoading;
